<template>

  <Loader v-if="loader" /> 

    <div class="card">

        <Toolbar class="p-mb-4">
            <template #start>
                <Button label="Nuovo" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
                <Button label="Cancella" icon="pi pi-trash" class="p-button-danger mr-2" @click="confirmDeleteSelected" :disabled="!selectedRecords || !selectedRecords.length" />
            </template>
            <template #end>                
                <Button label="Statistiche Tariffe" icon="pi pi-chart-bar" class="p-button-help ml-2" @click="openStatisticheTariffeDialog" />
                <Button label="Import Tariffe Gas" icon="pi pi-upload" class="p-button-info ml-2" @click="openImportTariffeGasDialog" :loading="importPreviewLoading || importTariffeGasLoading" />
                <Button label="Esporta" icon="pi pi-download" class="p-button-secondary ml-2" @click="exportCSV($event)"  />
            </template>
        </Toolbar>

        <div class="p-fluid mb-3 mt-3">
            <div class="grid">
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Data inizio</label>
                    <Calendar
                        :modelValue="filtroDataInizio"
                        view="month"
                        dateFormat="dd-mm-yy"
                        :showIcon="true"
                        :showButtonBar="true"
                        placeholder="Da"
                        @update:modelValue="onFiltroDataInizioMonthSelect"
                    />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Data fine</label>
                    <Calendar
                        :modelValue="filtroDataFine"
                        view="month"
                        dateFormat="dd-mm-yy"
                        :showIcon="true"
                        :showButtonBar="true"
                        placeholder="A"
                        @update:modelValue="onFiltroDataFineMonthSelect"
                    />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Code</label>
                    <MultiSelect
                        v-model="filterCodes"
                        :options="cluster_code"
                        optionLabel="code"
                        optionValue="code"
                        placeholder="Tutti"
                        display="chip"
                        class="w-full"
                    />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Zona</label>
                    <Dropdown v-model="filterZona" :options="zone" optionLabel="zona" optionValue="zona" placeholder="Tutte" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Tipo uso</label>
                    <Dropdown v-model="filterTipoUso" :options="type_uso" optionLabel="name" optionValue="name" placeholder="Tutti" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3">
                    <label class="block mb-1 text-sm">Tipo cliente</label>
                    <Dropdown v-model="filterTipoCliente" :options="type_client" optionLabel="name" optionValue="name" placeholder="Tutti" showClear class="w-full" />
                </div>
                <div class="col-12 md:col-6 lg:col-3 flex align-items-end">
                    <Button type="button" label="Azzera filtri" icon="pi pi-filter-slash" class="p-button-outlined w-full" @click="clearTariffeFilters" />
                </div>
            </div>
        </div>

        <TabView lazy>        
            <TabPanel v-for="tab in filteredTabs" :key="tab.title" :header="tab.title">
                <DataTable  ref="dt" :value="tab.filteredContent" dataKey="id" responsiveLayout="scroll" v-model:filters="filters" v-model:selection="selectedRecords"
                 :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[10,20,50]"
                    :globalFilterFields="globalFilterFields"
                    currentPageReportTemplate="{first} a {last} di {totalRecords}">
                    <template #header>
                        <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                            </span>
                        </div>
                    </template>
                    
                    <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
                    <Column field="code" header="Code" :sortable="true"></Column>
                    <Column field="zona" header="Zona" :sortable="true"></Column>
                    <Column field="data_inizio" header="Data inizio" :sortable="true" style="min-width: 130px">
                       <template #body="slotProps">
                          {{moment(slotProps.data.data_inizio).format('DD-MM-YYYY')}}            
                        </template>
                    </Column>
                    <Column field="data_fine" header="Data fine" :sortable="true" style="min-width: 130px">
                        <template #body="slotProps">
                          {{moment(slotProps.data.data_fine).format('DD-MM-YYYY')}}            
                        </template>
                    </Column>
                    <Column field="value" header="Valore" :sortable="true"></Column>                  
                    <Column field="from_classe" header="Da classe" :sortable="true"></Column>                  
                    <Column field="to_classe" header="A classe" :sortable="true"></Column> 
                    <Column field="from_smc" header="Da smc" :sortable="true"></Column>                  
                    <Column field="to_smc" header="A smc" :sortable="true"></Column>                  
                    <Column field="type_client" header="Tipo cliente" :sortable="true"></Column>                  
                    <Column field="type_uso" header="Tipo Uso" :sortable="true"></Column>                  
                    <!-- <Column header="Valore utilizzato" :sortable="true">
                        <template #body="slotProps">
                            <span v-if="slotProps.data.cod_type_cluster == 1">
                              {{((slotProps.data.value) / 100).toFixed(4)}}
                            </span>
                            <span v-else>
                              {{((slotProps.data.value /12) / 100).toFixed(4)}}
                            </span>                       
                        </template>
                    </Column> -->
                     <Column :exportable="false" style="min-width:17rem">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editRecord(slotProps.data)" />
                            <Button icon="pi pi-copy" class="p-button-rounded p-button-help mr-2" @click="openDuplicateRecord(slotProps.data)" />
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="confirmDeleteRecord(slotProps.data)" />
                        </template>
                    </Column> 
                </DataTable>        
            </TabPanel>
            
        </TabView>
    </div>

    <!-- DIALOG EDIT-->
    <Dialog  v-model:visible="recordDialog" :style="{width: '600px'}" :header="titleDialog" :modal="true" class="p-fluid">
        <div class="grid">
          <div class="col-12">
                <div class="p-field">
                  <label for="cod_cluster">Codice</label>
                  <Dropdown v-model="record.code" :options="cluster_code" optionLabel="code" optionValue="code" placeholder="Seleziona codice" />
                </div>
            </div> 
            <div class="col-6">
                <div class="p-field">
                    <label>Tipo Cliente </label>
                     <Dropdown v-model="record.cod_type_client" :options="type_client" optionLabel="name" optionValue="id" placeholder="Seleziona tipo cliente" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label>Tipo Uso</label>
                     <Dropdown  v-model="record.cod_type_uso" :options="type_uso" optionLabel="name" optionValue="id" placeholder="Seleziona tipo uso" />
                </div>
            </div> 
            <div class="col-12">
                <div class="p-field">
                    <label>Zona</label>
                     <Dropdown  v-model="record.zona" :options="zone" optionLabel="zona" optionValue="zona" placeholder="Seleziona zona" />
                </div>
            </div> 
            <div class="col-6">
                <div class="p-field">
                    <label>Da classe</label>
                    <InputText v-model="record.from_classe" required="true" autofocus  :value="record.from_classe" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label>A classe</label>
                    <InputText v-model="record.to_classe" required="true" autofocus  :value="record.to_classe" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label>Da smc</label>
                    <InputText v-model="record.from_smc" required="true" autofocus  :value="record.from_smc" />
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label>A smc</label>
                    <InputText v-model="record.to_smc" required="true" autofocus  :value="record.to_smc" />
                </div>
            </div> 
            <div class="col-6">
                <div class="p-field">
                    <label for="data_inizio" class="p-mb-3">Data inizio</label>
                    <Calendar id="data_inizio" v-model="record.data_inizio" view="month" dateFormat="dd-mm-yy" :yearNavigator="true" yearRange="2000:2090"/>
                </div>
            </div>
            <div class="col-6">
                <div class="p-field">
                    <label for="data_fine" class="p-mb-3">Data fine</label>
                    <Calendar id="data_fine" v-model="record.data_fine" view="month" dateFormat="dd-mm-yy" :yearNavigator="true" yearRange="2000:2090" />
                </div>
            </div>  
            <div class="col-12">
                <div class="p-field">
                    <label for="valore">Valore</label>
                    <InputText id="valore" v-model.trim="record.value" required="true" autofocus  :value="record.value" />
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-ml-auto p-button-danger" @click="hideDialog"/>
            <Button :label="record.id ? 'Salva' : 'Crea'" icon="pi pi-check" class="p-button-success mr-2" @click="saveRecord" />
        </template>
    </Dialog>

    <!-- DIALOG DELETE-->
    <Dialog v-model:visible="deleteRecordDialog" :style="{width: '600px'}" header="Conferma eliminazione" :modal="true">
        <div class="confirmation-content flex align-items-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="record">Eliminare questo elemento ?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecordDialog = false"/>
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteRecord" />
        </template>
    </Dialog>

    
    <Dialog v-model:visible="deleteRecordsDialog" :style="{width: '450px'}" header="Conferma eliminazione" :modal="true">
        <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="record">Confermi la cancellazione di {{selectedRecords.length}} elementi?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRecordsDialog = false"/>
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedRecords" />
        </template>
    </Dialog>

    <Dialog
        v-model:visible="statisticheTariffeDialog"
        :style="{ width: 'min(96vw, 1200px)' }"
        header="Statistiche Tariffe Gas"
        :modal="true"
        class="p-fluid statistiche-tariffe-dialog"
        @hide="onStatisticheTariffeDialogHide"
    >
        <div class="grid mb-3">
            <div class="col-12 md:col-3">
                <label class="block mb-1 text-sm">Data inizio periodo</label>
                <Calendar v-model="statDataDa" view="month" dateFormat="dd-mm-yy" :showIcon="true" placeholder="Da" class="w-full" />
            </div>
            <div class="col-12 md:col-3">
                <label class="block mb-1 text-sm">Data fine periodo</label>
                <Calendar v-model="statDataA" view="month" dateFormat="dd-mm-yy" :showIcon="true" placeholder="A" class="w-full" />
            </div>
            <div class="col-12 md:col-6">
                <label class="block mb-1 text-sm">Tipo cliente (uno o più)</label>
                <div class="flex align-items-end gap-2">
                    <div class="flex-grow-1" style="min-width: 0">
                        <MultiSelect
                            v-model="statCodTypeClients"
                            :options="type_client"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Seleziona tipo/i cliente"
                            display="chip"
                            :filter="true"
                            class="w-full"
                        />
                    </div>
                    <Button
                        type="button"
                        label="Cerca"
                        icon="pi pi-search"
                        class="p-button-sm stat-matrix-ricerca-btn flex-shrink-0 ml-2 mb-1"
                        :loading="statisticheTariffeLoading"
                        @click="runStatisticheTariffe"
                    />
                </div>
            </div>
        </div>

        <div v-for="blocco in statisticheBlocchi" :key="blocco.cod_type_client" class="mb-4">
                <h4 class="mt-0 mb-2 text-900">
                    {{ blocco.nomeCliente }}
                </h4>

                <Message v-if="blocco.fuoriGriglia.length" severity="warn" class="mb-3" :closable="false">
                    <div class="font-semibold mb-2">Combinazioni presenti nel periodo ma fuori dalla griglia di riferimento (code × uso)</div>
                    <ul class="m-0 pl-3 text-sm">
                        <li v-for="(fg, idx) in blocco.fuoriGriglia" :key="idx">
                            {{ fg.code }} — {{ fg.type_uso || ('Uso #' + fg.cod_type_uso) }}
                            <span class="text-600">({{ (fg.zone_con_tariffa || []).join(', ') }})</span>
                        </li>
                    </ul>
                </Message>

                <div v-if="blocco.codici.length && blocco.matrixRows.length" class="stat-matrix-wrap border-1 surface-border border-round">
                    <table class="stat-matrix-table">
                        <thead>
                            <tr>
                                <th class="stat-matrix-sticky text-left">Tipologia uso</th>
                                <th v-for="code in blocco.codici" :key="code" class="text-center">{{ code }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in blocco.matrixRows" :key="blocco.cod_type_client + '-' + row.cod_type_uso">
                                <td class="stat-matrix-sticky text-left font-medium">{{ row.label }}</td>
                                <td
                                    v-for="code in blocco.codici"
                                    :key="blocco.cod_type_client + '-' + code + '-' + row.cod_type_uso"
                                    class="stat-matrix-cell text-center stat-matrix-cell--click"
                                    :class="statCellClass(row.cells[code])"
                                    role="button"
                                    tabindex="0"
                                    @click="toggleStatCellDetail($event, blocco, row, code)"
                                    @keydown.enter.prevent="toggleStatCellDetail($event, blocco, row, code)"
                                    @keydown.space.prevent="toggleStatCellDetail($event, blocco, row, code)"
                                >
                                    <span class="stat-matrix-cell-label">{{ row.cells[code]?.trovato ? 'Sì' : 'No' }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="text-600 text-sm mb-0">Nessuna riga matrice per questo tipo cliente.</div>
        </div>

        <div v-if="!statisticheTariffeLoading && statisticheTariffeSearched && !statisticheBlocchi.length" class="text-600 text-sm">Nessun risultato da mostrare.</div>

        <OverlayPanel
            ref="statCellOverlayPanel"
            class="stat-cell-overlay-panel"
            :baseZIndex="12000"
            :showCloseIcon="true"
            @show="onStatOverlayShow"
            @hide="onStatOverlayHide"
        >
            <div v-if="statOverlayPayload" class="stat-overlay-panel-body text-sm">
                <div class="font-semibold mb-2 text-900 line-height-3">
                    {{ statOverlayPayload.bloccoNome }}
                </div>
                <div class="text-600 mb-2">
                    Code <strong class="text-900">{{ statOverlayPayload.code }}</strong>
                    · {{ statOverlayPayload.usoLabel }}
                </div>
                <div
                    v-for="(line, li) in statCellDetailLines(statOverlayPayload.cell)"
                    :key="li"
                    class="stat-overlay-panel-line"
                >
                    {{ line }}
                </div>
            </div>
        </OverlayPanel>
    </Dialog>

    <Dialog
        v-model:visible="importTariffeGasDialog"
        :style="{ width: importTariffeGasPreview ? 'min(95vw, 1100px)' : '500px' }"
        header="Import Tariffe Gas"
        :modal="true"
        class="p-fluid import-tariffe-gas-dialog"
        @hide="onImportTariffeGasDialogHide"
    >
        <div class="p-field">
            <label for="import_tariffe_gas_file" class="p-mb-2 block">File .xlsx</label>
            <input
                id="import_tariffe_gas_file"
                ref="importTariffeGasInput"
                type="file"
                accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                class="p-inputtext p-component w-full"
                @change="onImportTariffeGasSelected"
            />
            <small v-if="importTariffeGasFileName" class="block mt-2 text-600">{{ importTariffeGasFileName }}</small>
        </div>

        <div v-if="importTariffeGasPreview" class="mt-3">
            <Message severity="info" :closable="false" class="mb-3">
                <div class="font-semibold mb-2">Anteprima import</div>
                <div class="text-sm line-height-3">
                    Periodo:
                    <strong>{{ formatPreviewDate(importTariffeGasPreview.data_inizio) }}</strong>
                    —
                    <strong>{{ formatPreviewDate(importTariffeGasPreview.data_fine) }}</strong>
                </div>
            </Message>

            <Message
                v-if="importTariffeGasPreview.conteggi && !importTariffeGasImportAllowed"
                severity="error"
                :closable="false"
                class="mb-3"
            >
                Il file non può essere importato, alcuni dati sono già presenti.
            </Message>

            <div class="grid mb-3 text-sm" v-if="importTariffeGasPreview.conteggi">
                <div class="col-6 md:col-2"><span class="text-600">Righe generate</span><div class="font-bold text-lg">{{ importTariffeGasPreview.conteggi.righe_generate }}</div></div>
                <div class="col-6 md:col-2"><span class="text-600">Righe uniche</span><div class="font-bold text-lg">{{ importTariffeGasPreview.conteggi.righe_uniche }}</div></div>
                <div class="col-6 md:col-2"><span class="text-600">Inseribili</span><div class="font-bold text-lg text-green-700">{{ importTariffeGasPreview.conteggi.inseribili }}</div></div>
                <div class="col-6 md:col-2"><span class="text-600">Già presenti</span><div class="font-bold text-lg text-red-700">{{ importTariffeGasPreview.conteggi.gia_presenti }}</div></div>
            </div>

            <TabView>
                <TabPanel :header="'Inseribili (' + (importTariffeGasPreview.inseribili?.length || 0) + ')'">
                    <DataTable
                        :value="importTariffeGasPreview.inseribili || []"
                        responsiveLayout="scroll"
                        scrollable
                        scrollHeight="280px"
                        class="p-datatable-sm"
                        :paginator="(importTariffeGasPreview.inseribili || []).length > 10"
                        :rows="10"
                    >
                        <Column field="code" header="Code" sortable />
                        <Column field="zona" header="Zona" sortable />
                        <Column field="from_classe" header="Da classe" sortable />
                        <Column field="to_classe" header="A classe" sortable />
                        <Column field="from_smc" header="Da smc" sortable />
                        <Column field="to_smc" header="A smc" sortable />
                        <Column field="value" header="Valore" sortable />
                    </DataTable>
                </TabPanel>
                <TabPanel :header="'Non inseribili (' + (importTariffeGasPreview.non_inseribili?.length || 0) + ')'">
                    <DataTable
                        :value="importTariffeGasPreview.non_inseribili || []"
                        responsiveLayout="scroll"
                        scrollable
                        scrollHeight="280px"
                        class="p-datatable-sm"
                        :paginator="(importTariffeGasPreview.non_inseribili || []).length > 10"
                        :rows="10"
                    >
                        <Column field="code" header="Code" sortable />
                        <Column field="zona" header="Zona" sortable />
                        <Column field="from_classe" header="Da classe" sortable />
                        <Column field="to_classe" header="A classe" sortable />
                        <Column field="value" header="Valore" sortable />
                        <Column field="_motivo" header="Motivo" style="min-width: 14rem" />
                    </DataTable>
                </TabPanel>
                <TabPanel :header="'Duplicati nel file (' + (importTariffeGasPreview.duplicati_nel_file?.length || 0) + ')'">
                    <DataTable
                        :value="importTariffeGasPreview.duplicati_nel_file || []"
                        responsiveLayout="scroll"
                        scrollable
                        scrollHeight="280px"
                        class="p-datatable-sm"
                        :paginator="(importTariffeGasPreview.duplicati_nel_file || []).length > 10"
                        :rows="10"
                    >
                        <Column field="code" header="Code" sortable />
                        <Column field="zona" header="Zona" sortable />
                        <Column field="from_classe" header="Da classe" sortable />
                        <Column field="to_classe" header="A classe" sortable />
                        <Column field="value" header="Valore" sortable />
                        <Column field="_motivo" header="Motivo" style="min-width: 14rem" />
                    </DataTable>
                </TabPanel>
            </TabView>
        </div>

        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="closeImportTariffeGasDialog" />
            <Button
                v-if="!importTariffeGasPreview"
                label="Carica file"
                icon="pi pi-upload"
                class="p-button-secondary"
                :loading="importPreviewLoading"
                :disabled="!importTariffeGasFile"
                @click="loadImportTariffeGasPreview"
            />
            <Button
                v-if="importTariffeGasPreview"
                label="Nuova anteprima"
                icon="pi pi-refresh"
                class="p-button-outlined"
                :disabled="importPreviewLoading || importTariffeGasLoading"
                @click="resetImportTariffeGasPreview"
            />
            <Button
                v-if="importTariffeGasPreview"
                label="Conferma import"
                icon="pi pi-check"
                class="p-button-success"
                :loading="importTariffeGasLoading"
                :disabled="importPreviewLoading || importTariffeGasLoading || !importTariffeGasImportAllowed"
                @click="executeImportTariffeGas"
            />
        </template>
    </Dialog>

</template>

<script>
import { ref, computed, onMounted, getCurrentInstance, nextTick } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from 'primevue/usetoast';




export default {
    components: {
      Loader
    },
    setup() {

        const toast = useToast();
        const dt = ref();
        const importTariffeGasInput = ref(null);
        const importTariffeGasLoading = ref(false);
        const importPreviewLoading = ref(false);
        const importTariffeGasDialog = ref(false);
        const importTariffeGasFile = ref(null);
        const importTariffeGasFileName = ref('');
        const importTariffeGasPreview = ref(null);
        const loader = ref(false)
        const submitted = ref(false);
        const active = ref(0);

        const statisticheTariffeDialog = ref(false);
        const statisticheTariffeLoading = ref(false);
        const statisticheTariffeResult = ref(null);
        const statisticheTariffeSearched = ref(false);
        const statDataDa = ref(null);
        const statDataA = ref(null);
        const statCodTypeClients = ref([]);

        const tabs = ref([]);
        const type_client = ref([])
        const cluster_code = ref([])
        const type_uso = ref([])
        const zone = ref([])
        const record = ref({});
        const selectedRecords = ref();
        const recordDialog = ref(false);
        const deleteRecordsDialog = ref(false);
        const titleDialog = ref('');
        const deleteRecordDialog = ref(false);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const globalFilterFields = ['code', 'zona', 'data_inizio', 'data_fine', 'value', 'from_classe', 'to_classe', 'from_smc', 'to_smc', 'type_client', 'type_uso'];

        const defaultFiltroDateUltimiSeiMesi = () => ({
            inizio: moment().subtract(5, 'months').startOf('month').toDate(),
            fine: moment().endOf('month').toDate(),
        });
        const _defDate = defaultFiltroDateUltimiSeiMesi();
        const filtroDataInizio = ref(_defDate.inizio);
        const filtroDataFine = ref(_defDate.fine);
        const filterCodes = ref([]);
        const filterZona = ref(null);
        const filterTipoUso = ref(null);
        const filterTipoCliente = ref(null);

        const onFiltroDataInizioMonthSelect = (val) => {
            if (val == null || val === '') {
                filtroDataInizio.value = null;
                return;
            }
            filtroDataInizio.value = moment(val).startOf('month').toDate();
        };

        const onFiltroDataFineMonthSelect = (val) => {
            if (val == null || val === '') {
                filtroDataFine.value = null;
                return;
            }
            filtroDataFine.value = moment(val).endOf('month').toDate();
        };

        const calendarMonthStart = (v) => {
            if (v == null || v === '') {
                return null;
            }
            const m = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                ? moment(v.slice(0, 10), 'YYYY-MM-DD', true)
                : moment(v);
            return m.isValid() ? m.clone().startOf('month') : null;
        };
        const calendarMonthEnd = (v) => {
            if (v == null || v === '') {
                return null;
            }
            const m = typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                ? moment(v.slice(0, 10), 'YYYY-MM-DD', true)
                : moment(v);
            return m.isValid() ? m.clone().endOf('month') : null;
        };

        const parseApiDate = (v) => {
            if (v == null || v === '') {
                return null;
            }
            if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) {
                return moment(v.slice(0, 10), 'YYYY-MM-DD', true);
            }
            const m = moment(v);
            return m.isValid() ? m : null;
        };

        const asRowArray = (content) => {
            if (!content) {
                return [];
            }
            if (Array.isArray(content)) {
                return content;
            }
            if (typeof content === 'object') {
                return Object.values(content);
            }
            return [];
        };
        const normalizeCode = (value) => String(value ?? '').trim().toUpperCase();

        const openEndDay = moment('2199-12-31').endOf('day');

        const applyTariffeFilters = (rows, rangeStart, rangeEnd, codes, z, tu, tc) => {
            const list = asRowArray(rows);
            if (!list.length) {
                return list;
            }
            const selectedCodes = (codes || []).map(normalizeCode).filter(Boolean);
            return list.filter((row) => {
                if (selectedCodes.length && !selectedCodes.includes(normalizeCode(row.code))) {
                    return false;
                }
                if (z != null && z !== '' && row.zona !== z) {
                    return false;
                }
                if (tu != null && tu !== '' && row.type_uso !== tu) {
                    return false;
                }
                if (tc != null && tc !== '' && row.type_client !== tc) {
                    return false;
                }
                if (!rangeStart && !rangeEnd) {
                    return true;
                }
                const rs = parseApiDate(row.data_inizio);
                if (!rs || !rs.isValid()) {
                    return false;
                }
                const rowStart = rs.clone().startOf('day');
                const re = parseApiDate(row.data_fine);
                const rowEnd = (re && re.isValid()) ? re.clone().endOf('day') : openEndDay.clone();
                if (rangeStart && rangeEnd) {
                    return rowStart.isSameOrAfter(rangeStart, 'day') && rowEnd.isSameOrBefore(rangeEnd, 'day');
                }
                if (rangeStart) {
                    return rowStart.isSameOrAfter(rangeStart, 'day');
                }
                return rowEnd.isSameOrBefore(rangeEnd, 'day');
            });
        };

        const filteredTabs = computed(() => {
            const rangeStart = filtroDataInizio.value ? calendarMonthStart(filtroDataInizio.value) : null;
            const rangeEnd = filtroDataFine.value ? calendarMonthEnd(filtroDataFine.value) : null;
            const codes = filterCodes.value;
            const z = filterZona.value;
            const tu = filterTipoUso.value;
            const tc = filterTipoCliente.value;
            if (codes && codes.length) {
                const allRows = tabs.value.flatMap((tab) => asRowArray(tab.content));
                return [{
                    title: 'Risultati filtro per code',
                    content: allRows,
                    filteredContent: applyTariffeFilters(allRows, rangeStart, rangeEnd, codes, z, tu, tc),
                }];
            }
            return tabs.value.map((tab) => ({
                title: tab.title,
                content: tab.content,
                filteredContent: applyTariffeFilters(tab.content, rangeStart, rangeEnd, codes, z, tu, tc),
            }));
        });

        const clearTariffeFilters = () => {
            const def = defaultFiltroDateUltimiSeiMesi();
            filtroDataInizio.value = def.inizio;
            filtroDataFine.value = def.fine;
            filterCodes.value = [];
            filterZona.value = null;
            filterTipoUso.value = null;
            filterTipoCliente.value = null;
        };

        const buildStatMatrixRows = (payload) => {
            if (!payload) {
                return [];
            }
            const codici = payload.codici_riferimento || [];
            const usos = payload.cod_type_uso_considerati || [];
            if (!codici.length || !usos.length) {
                return [];
            }
            const dettaglio = payload.dettaglio || [];
            const lookup = new Map(dettaglio.map((d) => [`${d.code}|${d.cod_type_uso}`, d]));
            return usos.map((cod) => {
                const first = dettaglio.find((d) => d.cod_type_uso === cod);
                const label = first?.type_uso || `Uso #${cod}`;
                const cells = {};
                for (const code of codici) {
                    cells[code] = lookup.get(`${code}|${cod}`) || {
                        trovato: false,
                        code,
                        cod_type_uso: cod,
                        type_uso: label,
                        righe_periodo: 0,
                        zone_con_tariffa: [],
                    };
                }
                return { cod_type_uso: cod, label, cells };
            });
        };

        const nomeTipoClienteStat = (id) => {
            const c = type_client.value.find((x) => x.id === id);
            return c?.name || '—';
        };

        const statisticheBlocchi = computed(() => {
            const root = statisticheTariffeResult.value;
            if (!root?.risultati?.length) {
                return [];
            }
            return root.risultati.map((r) => ({
                cod_type_client: r.cod_type_client,
                nomeCliente: nomeTipoClienteStat(r.cod_type_client),
                codici: r.codici_riferimento || [],
                fuoriGriglia: r.fuori_griglia || [],
                matrixRows: buildStatMatrixRows(r),
            }));
        });

        const statCellClass = (cell) => ({
            'stat-matrix-cell--ok': cell?.trovato,
            'stat-matrix-cell--ko': cell && !cell.trovato,
        });

        const statCellOverlayPanel = ref(null);
        const statOverlayPayload = ref(null);
        const statOverlayOpen = ref(false);

        const onStatOverlayShow = () => {
            statOverlayOpen.value = true;
        };

        const onStatOverlayHide = () => {
            statOverlayOpen.value = false;
        };

        const hideStatCellOverlay = () => {
            statCellOverlayPanel.value?.hide();
            statOverlayPayload.value = null;
            statOverlayOpen.value = false;
        };

        const toggleStatCellDetail = async (event, blocco, row, code) => {
            const panel = statCellOverlayPanel.value;
            if (!panel) {
                return;
            }
            const key = `${blocco.cod_type_client}|${row.cod_type_uso}|${code}`;

            if (statOverlayPayload.value?.key === key && statOverlayOpen.value) {
                panel.hide();
                statOverlayPayload.value = null;
                return;
            }

            if (statOverlayOpen.value) {
                panel.hide();
                await nextTick();
            }

            statOverlayPayload.value = {
                key,
                cell: row.cells[code],
                code,
                usoLabel: row.label,
                bloccoNome: blocco.nomeCliente,
            };
            panel.show(event);
        };

        const statCellDetailLines = (cell) => {
            if (!cell) {
                return [];
            }
            if (cell.trovato) {
                return [
                    'Esito: trovato',
                    `Righe periodo: ${cell.righe_periodo ?? 0}`,
                    `Zone con tariffa: ${(cell.zone_con_tariffa || []).join(', ') || '—'}`,
                    `Zone senza tariffa: ${(cell.zone_senza_tariffa || []).join(', ') || '—'}`,
                    `Copertura zone completa: ${cell.copertura_zone_completa ? 'sì' : 'no'}`,
                ];
            }
            return ['Esito: non trovato (nessuna zona con tariffa nel periodo).'];
        };

        const openStatisticheTariffeDialog = () => {
            const def = defaultFiltroDateUltimiSeiMesi();
            statDataDa.value = def.inizio;
            statDataA.value = def.fine;
            statCodTypeClients.value = [];
            statisticheTariffeResult.value = null;
            statisticheTariffeSearched.value = false;
            hideStatCellOverlay();
            statisticheTariffeDialog.value = true;
        };

        const onStatisticheTariffeDialogHide = () => {
            statisticheTariffeLoading.value = false;
            hideStatCellOverlay();
        };

        const runStatisticheTariffe = async () => {
            if (!statDataDa.value || !statDataA.value) {
                toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona data inizio e data fine.', life: 5000 });
                return;
            }
            const ids = (statCodTypeClients.value || [])
                .map((v) => Number(v))
                .filter((n) => Number.isFinite(n) && n > 0);
            if (!ids.length) {
                toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona almeno un tipo cliente.', life: 5000 });
                return;
            }
            const mDa = moment(statDataDa.value).startOf('month');
            const mA = moment(statDataA.value).endOf('month');
            if (!mDa.isValid() || !mA.isValid()) {
                toast.add({ severity: 'error', summary: 'Date non valide', detail: 'Controlla le date inserite.', life: 5000 });
                return;
            }
            if (mDa.isAfter(mA, 'day')) {
                toast.add({ severity: 'warn', summary: 'Periodo non valido', detail: 'La data inizio non può essere successiva alla data fine.', life: 5000 });
                return;
            }
            const data_da = mDa.format('YYYY-MM-DD');
            const data_a = mA.format('YYYY-MM-DD');
            hideStatCellOverlay();
            statisticheTariffeLoading.value = true;
            try {
                const data = await service.getStatisticheTariffeGas(data_da, data_a, ids);
                statisticheTariffeResult.value = data;
                statisticheTariffeSearched.value = true;
            } catch (err) {
                const msg = err.response?.data?.message || err.message || 'Errore durante il caricamento delle statistiche';
                toast.add({ severity: 'error', summary: 'Richiesta non riuscita', detail: msg, life: 8000 });
                statisticheTariffeResult.value = null;
            } finally {
                statisticheTariffeLoading.value = false;
            }
        };

        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        
        onMounted(() => {          
          getData();
        })

        const getData = () => {
            loader.value = true; 
            service.getAllTariffeGas().then((res) => {

                tabs.value = [];
                for (const [key, item] of Object.entries(res.items.tariffe)) {
                    tabs.value.push({title: key, content: item});                                               
                }
                if ( Object.entries(tabs.value).length > 0) {
                  record.value = {...tabs.value[0].content[0]}
                }
                cluster_code.value = [];
                type_client.value = [];
                type_uso.value = [];
                zone.value = [];
                for (const item of Object.entries(res.items.cluster_code)) {
                    cluster_code.value.push(item[1]);                                               
                }
                for (const item of Object.entries(res.items.cod_client)) {
                    type_client.value.push(item[1]);                                               
                }
                for (const item of Object.entries(res.items.cod_uso)) {
                    type_uso.value.push(item[1]);                                               
                }
                for (const item of Object.entries(res.items.zone)) {
                    zone.value.push(item[1]);                                               
                } 
            }).finally(() => {
                loader.value = false;
            })
        }


        const openNew = () => {  
          submitted.value = false;
          titleDialog.value = 'Nuovo'              
          record.value.id = null;
          recordDialog.value = true;
        };

        const editRecord = (prod) => {
            titleDialog.value = 'Modifica'
            record.value = {...prod};
            recordDialog.value = true;
        };

        const cloneRecordForForm = (src) => {
            const copy = { ...src };
            delete copy.id;
            if (copy.data_inizio) {
                copy.data_inizio = moment(copy.data_inizio).toDate();
            }
            if (copy.data_fine) {
                copy.data_fine = moment(copy.data_fine).toDate();
            }
            return copy;
        };

        const openDuplicateRecord = (prod) => {
            if (!prod) {
                return;
            }
            submitted.value = false;
            titleDialog.value = 'Duplica offerta';
            record.value = cloneRecordForForm(prod);
            recordDialog.value = true;
        };

        const openDuplicateFromSelection = () => {
            const sel = selectedRecords.value;
            if (!sel || sel.length !== 1) {
                return;
            }
            openDuplicateRecord(sel[0]);
        };

        const hideDialog = () => {
            submitted.value = false;
            recordDialog.value = false;
        };
        const saveRecord = () => {
          console.log(record.value);
            record.value.data_inizio = moment(record.value.data_inizio).startOf('month').format('YYYY-MM-DD')
            record.value.data_fine = moment(record.value.data_fine).endOf('month').format('YYYY-MM-DD')
            if (record.value.id) {
                service.editTariffeGas(record.value)
                .then(() => {
                    getData()  
                })           
            } else {
                service.createTariffaGas(record.value)
                .then(() => {
                    getData()    
                })
            }

            recordDialog.value = false;
            record.value = {}; 
        
        };



        const confirmDeleteRecord = (prod) => {
            record.value = prod;
            deleteRecordDialog.value = true;
        };
        const deleteRecord = () => {
            service.deleteTariffaGas(record.value).then(() => {
                getData()  
            }).finally(() => {
                deleteRecordDialog.value = false;
                record.value = {};
            })          
        };

        const confirmDeleteSelected = () => {
            deleteRecordsDialog.value = true;
        };
        const deleteSelectedRecords = () => {
          service.deleteTariffeGas(selectedRecords.value).then(() => {
              getData()     
          }).finally(()=>{ 
              deleteRecordsDialog.value = false;
              selectedRecords.value = null;
          });
        };

        const exportCSV = () => {    
            dt.value.exportCSV()                    
        };

        const openImportTariffeGasDialog = () => {
            importTariffeGasFile.value = null;
            importTariffeGasFileName.value = '';
            importTariffeGasPreview.value = null;
            if (importTariffeGasInput.value) {
                importTariffeGasInput.value.value = '';
            }
            importTariffeGasDialog.value = true;
        };

        const onImportTariffeGasDialogHide = () => {
            importTariffeGasPreview.value = null;
            importPreviewLoading.value = false;
        };

        const closeImportTariffeGasDialog = () => {
            importTariffeGasDialog.value = false;
            importTariffeGasPreview.value = null;
            importTariffeGasFile.value = null;
            importTariffeGasFileName.value = '';
            if (importTariffeGasInput.value) {
                importTariffeGasInput.value.value = '';
            }
        };

        const resetImportTariffeGasPreview = () => {
            importTariffeGasPreview.value = null;
        };

        const formatPreviewDate = (d) => {
            if (d == null || d === '') {
                return '—';
            }
            const m = moment(d);
            return m.isValid() ? m.format('DD/MM/YYYY') : String(d);
        };

        const onImportTariffeGasSelected = (evt) => {
            const input = evt.target;
            const file = input.files && input.files[0];
            if (!file) {
                importTariffeGasFile.value = null;
                importTariffeGasFileName.value = '';
                importTariffeGasPreview.value = null;
                return;
            }
            importTariffeGasFile.value = file;
            importTariffeGasFileName.value = file.name;
            importTariffeGasPreview.value = null;
        };

        const loadImportTariffeGasPreview = async () => {
            if (!importTariffeGasFile.value) {
                return;
            }
            importPreviewLoading.value = true;
            try {
                const data = await service.previewImportTariffeGas(importTariffeGasFile.value);
                importTariffeGasPreview.value = data;
            } catch (err) {
                const msg = err.response?.data?.message || err.message || 'Errore durante l\'anteprima';
                toast.add({
                    severity: 'error',
                    summary: 'Anteprima non riuscita',
                    detail: msg,
                    life: 8000,
                });
                importTariffeGasPreview.value = null;
            } finally {
                importPreviewLoading.value = false;
            }
        };

        const importTariffeGasImportAllowed = computed(() => {
            const p = importTariffeGasPreview.value;
            if (!p?.conteggi) {
                return false;
            }
            const c = p.conteggi;
            const gia = Number(c.gia_presenti ?? 0);
            const dup = Number(c.duplicati_nel_file ?? 0);
            return gia === 0 && dup === 0;
        });

        const executeImportTariffeGas = async () => {
            if (!importTariffeGasFile.value || !importTariffeGasPreview.value) {
                return;
            }
            if (!importTariffeGasImportAllowed.value) {
                return;
            }
            importTariffeGasLoading.value = true;
            try {
                await service.importTariffeGas(importTariffeGasFile.value);
                filtroDataInizio.value = null;
                filtroDataFine.value = null;
                filterCodes.value = [];
                filterZona.value = null;
                filterTipoUso.value = null;
                filterTipoCliente.value = null;
                filters.value.global.value = null;
                selectedRecords.value = null;
                closeImportTariffeGasDialog();
                getData();
            } catch (err) {
                const msg = err.response?.data?.message || err.message || 'Errore durante l\'import';
                toast.add({
                    severity: 'error',
                    summary: 'Import non riuscito',
                    detail: msg,
                    life: 8000,
                });
            } finally {
                importTariffeGasLoading.value = false;
            }
        };

        return { 
          moment, dt, importTariffeGasInput, importTariffeGasLoading, importPreviewLoading, importTariffeGasDialog, importTariffeGasFile, importTariffeGasFileName,
          importTariffeGasPreview, importTariffeGasImportAllowed,
          openImportTariffeGasDialog, onImportTariffeGasSelected, onImportTariffeGasDialogHide,
          closeImportTariffeGasDialog, loadImportTariffeGasPreview, resetImportTariffeGasPreview, executeImportTariffeGas, formatPreviewDate,
          active, tabs, filteredTabs, getData, loader, filters, globalFilterFields, selectedRecords, record, exportCSV, editRecord, recordDialog, hideDialog,
          saveRecord, confirmDeleteRecord, deleteRecord, deleteRecordDialog, type_client, type_uso, openNew, openDuplicateRecord, openDuplicateFromSelection, zone,
          titleDialog, confirmDeleteSelected, deleteRecordsDialog, deleteSelectedRecords, cluster_code,
          filtroDataInizio, filtroDataFine, filterCodes, filterZona, filterTipoUso, filterTipoCliente,
          onFiltroDataInizioMonthSelect, onFiltroDataFineMonthSelect,
          clearTariffeFilters,
          statisticheTariffeDialog, statisticheTariffeLoading, statisticheTariffeResult, statisticheTariffeSearched,
          statDataDa, statDataA, statCodTypeClients,
          openStatisticheTariffeDialog, onStatisticheTariffeDialogHide, runStatisticheTariffe,
          statisticheBlocchi, statCellClass,
          statCellOverlayPanel, statOverlayPayload, toggleStatCellDetail, statCellDetailLines,
          onStatOverlayShow, onStatOverlayHide,
        }
    }
}
</script>

<style lang="css">
.tab-container {
    padding: 20px;
}
.tabview-custom i, .tabview-custom span  {

        vertical-align: middle;
}  

.tabview-custom span {
        margin: 0 .5rem;
    }


.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.p-tabview .p-tabview-panels {
    padding: 0px !important;
}

.badge-cluster {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 10px;
}
.bg-kwh {
    background-color: rgb(163, 221, 2);
}
.bg-kw {
    background-color:rgb(252, 94, 94) ;
}
.bg-mese {
    background-color:rgb(152, 230, 240) ;
}

.stat-matrix-wrap {
    overflow: auto;
    max-height: min(60vh, 520px);
}

.stat-matrix-table {
    border-collapse: separate;
    border-spacing: 0;
    width: max-content;
    min-width: 100%;
    font-size: 0.875rem;
}

.stat-matrix-table th,
.stat-matrix-table td {
    border: 1px solid var(--surface-border, #dee2e6);
    padding: 0.4rem 0.5rem;
    white-space: nowrap;
}

.stat-matrix-table thead th {
    background: var(--surface-100, #f8f9fa);
    position: sticky;
    top: 0;
    z-index: 2;
}

.stat-matrix-sticky {
    position: sticky;
    left: 0;
    z-index: 3;
    background: var(--surface-0, #fff);
    min-width: 11rem;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.06);
}

.stat-matrix-table thead .stat-matrix-sticky {
    z-index: 4;
    background: var(--surface-100, #f8f9fa);
}

.stat-matrix-cell--ok {
    background-color: #d4edda !important;
    color: #155724;
    font-weight: 600;
}

.stat-matrix-cell--ko {
    background-color: #f8d7da !important;
    color: #721c24;
    font-weight: 600;
}

.stat-matrix-cell-label {
    display: inline-block;
    min-width: 1.5rem;
}

.statistiche-tariffe-dialog.p-fluid .stat-matrix-ricerca-btn {
    width: auto !important;
}

.stat-matrix-cell--click {
    cursor: pointer;
    vertical-align: top;
}

.stat-matrix-cell--click:focus {
    outline: 2px solid var(--primary-color, #0d6efd);
    outline-offset: -2px;
}

.stat-cell-overlay-panel.p-overlaypanel {
    max-width: min(22rem, 92vw);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
}

.stat-overlay-panel-body {
    min-width: 14rem;
}

.stat-overlay-panel-line + .stat-overlay-panel-line {
    margin-top: 0.25rem;
}
</style>




